import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PrivacyPage() {
  const { t } = useTranslation("legal");

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6" data-testid="back-to-home">
            <ChevronLeft className="h-4 w-4 mr-1" />
            {t("back")}
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 mb-8">{t("privacyTitle")}</h1>

        <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyCollectTitle")}</h2>
            <p>{t("privacyCollectIntro")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("privacyCollectItem1")}</li>
              <li>{t("privacyCollectItem2")}</li>
              <li>{t("privacyCollectItem3")}</li>
              <li>{t("privacyCollectItem4")}</li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyPurposeTitle")}</h2>
            <p>{t("privacyPurposeIntro")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("privacyPurposeItem1")}</li>
              <li>{t("privacyPurposeItem2")}</li>
              <li>{t("privacyPurposeItem3")}</li>
              <li>{t("privacyPurposeItem4")}</li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyShareTitle")}</h2>
            <p>{t("privacyShareP1")}</p>
            <p className="mt-2">{t("privacyShareP2")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("privacyShareItem1")}</li>
              <li>{t("privacyShareItem2")}</li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacySecurityTitle")}</h2>
            <p>{t("privacySecurityIntro")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("privacySecurityItem1")}</li>
              <li>{t("privacySecurityItem2")}</li>
              <li>{t("privacySecurityItem3")}</li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyRetentionTitle")}</h2>
            <p>{t("privacyRetentionP1")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyRightsTitle")}</h2>
            <p>{t("privacyRightsIntro")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("privacyRightsItem1")}</li>
              <li>{t("privacyRightsItem2")}</li>
              <li>{t("privacyRightsItem3")}</li>
            </ul>
            <p className="mt-3"><strong>{t("privacyRightsContact")}</strong> wo.consulting@hotmail.com</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyCookiesTitle")}</h2>
            <p>{t("privacyCookiesP1")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyChangesTitle")}</h2>
            <p>{t("privacyChangesP1")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("privacyContactTitle")}</h2>
            <p>{t("privacyContactIntro")}</p>
            <p className="mt-2"><strong>{t("legalEditorEmail")}</strong> wo.consulting@hotmail.com</p>
          </section>
        </div>

        <p className="text-center text-sm text-slate-400 mt-8">{t("footerCredit")}</p>
      </div>
    </div>
  );
}
